import { base } from "../../common/config";
import axios from 'axios'

export const GetArticleByPage = function (pageParam) {
    return axios({
        url: `${base}/api/Content/Article/GetArticleByPage`,
        method: 'POST',
        data: pageParam
    })
}

export const GetArticleById = function (ArticleId) {
    return axios({
        url: `${base}/api/Content/Article/GetOne?ArticleId=${ArticleId}`,
        method: 'GET'
    })
}

export const CreateArticle = function (param) {
    return axios({
        url: `${base}/api/Content/Article/Put`,
        method: 'POST',
        data: param
    })
}

export const UpdateArticle = function (ArticleId, param) {
    return axios({
        url: `${base}/api/Content/Article/Post?ArticleId=${ArticleId}`,
        method: 'POST',
        data: param
    })
}

export const DeleteArticle = function (ArticleId) {
    return axios({
        url: `${base}/api/Content/Article/Delete?ArticleId=${ArticleId}`,
        method: 'POST'
    })
}


export const SaveProtocol = function (param) {
    return axios({
        url: `${base}/api/Content/Article/SaveProtocol`,
        method: 'POST',
        data: param
    })
}

export const GetArticleForProtocol = function () {
    return axios({
        url: `${base}/api/Content/Article/GetArticleForProtocol`,
        method: 'GET'
    })
}

export const GetArticles = function (ArticleCategoryId) {
    ArticleCategoryId=ArticleCategoryId||"";
    return axios({
        url: `${base}/api/Content/Article/GetArticles?ArticleCategoryId=${ArticleCategoryId}`,
        method: 'GET'
    })
}

export const GetFrontArticleByPage = function (pageParam) {
    return axios({
        url: `${base}/api/Content/Article/GetFrontArticleByPage`,
        method: 'POST',
        data:pageParam
    })
}

export const GetFrontArticleById = function (ArticleId) {
    return axios({
        url: `${base}/api/Content/Article/GetFrontArticleById?ArticleId=${ArticleId}`,
        method: 'GET'
    })
}


// WEBPACK FOOTER //
// ./src/api/content/article.js